import { Component, OnInit, isDevMode } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quote-zip',
  templateUrl: './quote-zip.component.html',
  styleUrls: ['./quote-zip.component.scss']
})
export class QuoteZipComponent implements OnInit {
  form!: FormGroup
  inDev = isDevMode()
  constructor(private rootFormGroup: FormGroupDirective) {    
  }

  ngOnInit() : void {
    this.form = this.rootFormGroup.control
  }
}
